import { Option } from '@/app/component/form/types'
import { reminderSupportedMessageTypes } from '@/app/module/campaigns/models/reminder/message'
import { CampaignTemplateType, RangeType } from '@/app/module/campaigns/types'

export const QUOTA_ACTIONS_DISABLED_REASON = 'No quotas are set up for this campaign. Add one to enable this part.'

// Chatbot intentionally excluded until content types are defined
export const contentTypeList: Record<Exclude<CampaignTemplateType, CampaignTemplateType.Chatbot>, Option[]> = {
  [CampaignTemplateType.CATI]: [
    {
      label: 'CATI Message',
      value: 'cati-m',
    },
    {
      label: 'CATI Question',
      value: 'cati-q',
    },
    {
      label: 'Actions Only',
      value: 'action-q',
    },
  ],
  [CampaignTemplateType.Drip]: [
    {
      label: 'SMS Message',
      value: 'sms-m',
    },
    {
      label: 'SMS Question',
      value: 'sms-q',
    },
    {
      label: 'Voice Message',
      value: 'voice-m',
    },
    {
      label: 'Voice Question',
      value: 'voice-q',
    },
    {
      label: 'WhatsApp Message',
      value: 'whatsapp-m',
    },
    {
      label: 'WhatsApp Question',
      value: 'whatsapp-q',
    },
    {
      label: 'Actions Only',
      value: 'action-q',
    },
    {
      label: 'Quota Actions',
      value: 'quota-q',
    },
    {
      label: 'Airtime Top-up',
      value: 'topup-q',
    },
    {
      label: 'API Request',
      value: 'api-q',
    },
  ],
  [CampaignTemplateType.Reminder]: reminderSupportedMessageTypes,
  [CampaignTemplateType.SMSBlast]: [
    {
      label: 'SMS Message',
      value: 'sms-m',
    },
  ],
  [CampaignTemplateType.SMSSurvey]: [
    {
      label: 'SMS Message',
      value: 'sms-m',
    },
    {
      label: 'SMS Question',
      value: 'sms-q',
    },
    {
      label: 'API Request',
      value: 'api-q',
    },
    {
      label: 'Actions Only',
      value: 'action-q',
    },
  ],
  [CampaignTemplateType.VoiceBlast]: [
    {
      label: 'Voice Message',
      value: 'voice-m',
    },
    {
      label: 'Voice Question',
      value: 'voice-q',
    },
    {
      label: 'Actions Only',
      value: 'action-q',
    },
  ],
  [CampaignTemplateType.VoiceSurvey]: [
    {
      label: 'Voice Message',
      value: 'voice-m',
    },
    {
      label: 'Voice Question',
      value: 'voice-q',
    },
    {
      label: 'Actions Only',
      value: 'action-q',
    },
    {
      label: 'Quota Actions',
      value: 'quota-q',
    },
  ],
  [CampaignTemplateType.WhatsAppSurvey]: [
    {
      label: 'WhatsApp Message',
      value: 'whatsapp-m',
    },
    {
      label: 'WhatsApp Question',
      value: 'whatsapp-q',
    },
    {
      label: 'WhatsApp Form',
      value: 'whatsapp-f',
    },
    {
      label: 'API Request',
      value: 'api-q',
    },
    {
      label: 'Actions Only',
      value: 'action-q',
    },
  ],
}

export const pageSizeValue = [
  {
    label: '5',
    value: 5,
  },
  {
    label: '10',
    value: 10,
  },
  {
    label: '20',
    value: 20,
  },
  {
    label: '50',
    value: 50,
  },
  {
    label: '100',
    value: 100,
  },
]

export const emptyRanges: RangeType[] = []
export const emptyReplies: string[] = []
